export default __webpack_public_path__ + "1f651f5fa541f7c8cb01d5bdedbb0855.svg";